import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import OwnedEquipment from './ownedEquipment/index';
import SharedWithMe from './sharedWithMe/index';
import { setEquipmentCustomerDetailsAction } from '../../../stores/actionTypes/equipmentInfoActions';
import { useDispatch } from 'react-redux';
import { useHook as equipmentInfo } from './useHook';

const Equipment = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { fetchGetEquipmentFilter } = equipmentInfo();

  const [activeOwnedEquipment, setActiveOwnedEquipment] = useState(false);
  useEffect(() => {
    pathname === '/equipment/ownedequipment'
      ? setActiveOwnedEquipment(true)
      : setActiveOwnedEquipment(false);
    dispatch(setEquipmentCustomerDetailsAction({}));
  }, [pathname]);

  const handlePageChange = (page: string) => {
    if (pathname !== page) {
      navigate(page);
    }
  };
  useEffect(() => {
    fetchGetEquipmentFilter();
  }, []);
  return (
    <>
      <div className="audilog_update">
        <Button
          className={activeOwnedEquipment ? 'activeEdit' : ''}
          onClick={() => handlePageChange('/equipment/ownedequipment')}
        >
          Owned Equipment
        </Button>
        <Button
          className={!activeOwnedEquipment ? 'activeEdit' : ''}
          onClick={() => handlePageChange('/equipment/sharedwithmeequipment')}
        >
          Shared Equipment
        </Button>
      </div>
      {activeOwnedEquipment ? <OwnedEquipment /> : <SharedWithMe />}
    </>
  );
};

export default Equipment;
